import { App } from './../app.class';
import { Modal } from './../modal.class';
import { Notification } from './../notification.class';
import { Fetch } from '../../fetch.class';

export class Page {

    constructor() {

        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;

        // Basis-URL zu Prozessor
        this.baseUrl = App.getUrl('form-delivery')+"/"+this.form_code+"/whatsapp";


        // --- Webadresse

        // Elemente
        this.$btnEdit = document.querySelector('button.phonenumber');
        this.$inputEdit = document.querySelector('#modal-edit-phonenumber input[name=phonenumber]');
        this.$displayValue = document.querySelector('#value_phonenumber');
        this.$formEdit = document.querySelector('#modal-edit-phonenumber form');
        this.$errorboxEdit = document.querySelector('#modal-edit-phonenumber .errorbox');

        // Modal
        this.modalEdit = new Modal('#modal-edit-phonenumber');

        // Modaldialog öffnen
        this.$btnEdit.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEdit.classList.add('hidden');

            // Modal öffnen
            this.modalEdit.show();
        });

        // Speicherung
        this.$formEdit.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("phonenumber", this.$inputEdit.value);

            // Fehler ausblenden
            this.$errorboxEdit.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+"/save_phonenumber", data)
            .then(response => {

                // Modal schliessen
                this.modalEdit.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displayValue.textContent = response.phonenumber;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEdit.querySelector('.cont').textContent = error.message;
                this.$errorboxEdit.classList.remove('hidden');
            });
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-delivery-whatsapp')) {
        new Page();
    }
});